import * as _ from 'underscore';

import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { CreativeAdSize, CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { DisplayCreativeComponent } from '../display-creative/display-creative.component';

@Component({
	selector: 'app-creative-detail-v7',
	styleUrls: ['./creative-detail-v7.component.css'],
	templateUrl: './creative-detail-v7.component.html'
})
export class CreativeDetailV7Component extends DisplayCreativeComponent implements OnInit {
	public isSocial: boolean;
	public isPreroll: boolean;
	public isCtv: boolean;
	@Input() legend: any;
	@Input() sectionclass: string;
	public minClass: any;
	public isRadio: boolean;
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';

	constructor(
		protected analyticsService: AnalyticsService,
		protected modalService: ModalService,
		protected sanitizer: DomSanitizer,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, modalService, sanitizer, analyticsDataModel);
	}

	ngOnInit(): void {
		this.isSocial = this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
		this.isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
		if (this.legend) {
			this.legend = JSON.parse(decodeURI(this.legend));
			this.legend = _.filter(this.legend, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.isCtv = this.analyticsDataModel.getCurrentPath() === PATHS.CTV;
		this.minClass = this.sectionclass.split(' ')[0];
		this.isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
		super.ngOnInit();
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
	}

	processResponseData(responseData: any): void {
		if (responseData.length > 0) {
			responseData.map((data) => {
				if (!data.creative_name) {
					data['creative_name'] = data.name;
				}
			});
			this.creatives = this.mapResponseDataToInterface(responseData);
			if (!this.isRadio) this.creatives = _.sortBy(this.creatives, 'impressions').reverse();
			this.displayIndex = 0;
			this.totalCreatives = this.creatives.length;
			this.setSlide();
			this.setDisplayIndexContent(this.displayIndex);
		} else {
			this.hasData = false;
		}
	}

	mapResponseDataToInterface(responseData: any): any {
		const creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: CreativePerformance = {} as CreativePerformance;
			creativeObj.creativeName = response.creative_name || response.name;
			creativeObj.versionId = parseFloat(response.cup_version_id);
			creativeObj.clicks = parseFloat(response.clicks);
			creativeObj.clickRate = parseFloat(response.click_rate).toFixed(2);
			creativeObj.adInteractions = Number.isNaN(parseFloat(response.ad_interactions))
				? null
				: parseFloat(Number(response.ad_interactions).toFixed(2));
			creativeObj.adInteractionRate = Number.isNaN(parseFloat(response.interaction_rate))
				? null
				: parseFloat(response.interaction_rate).toFixed(2);
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.isVideoCreative = !UtilityService.isUndefined(response.video_url || response.mp4);
			creativeObj.isAudioCreative = !UtilityService.isUndefined(response.audio_url);
			creativeObj.creativeThumbnail = UtilityService.isUndefinedOrNull(response.creative_thumbnail_image)
				? this.placeholderimage
				: UtilityService.checkEncodeURI(response.creative_thumbnail_image)
				? response.creative_thumbnail_image
				: encodeURI(response.creative_thumbnail_image);
			if (response.thumbnail) {
				creativeObj.creativeThumbnail = UtilityService.checkEncodeURI(response.thumbnail)
					? response.thumbnail
					: encodeURI(response.thumbnail);
			}
			creativeObj.iframeUrl = UtilityService.isUndefinedOrNull(response.iframe_url) ? null : response.iframe_url;
			if (creativeObj.isVideoCreative) {
				creativeObj.creativeVideo = response.video_url || response.mp4;
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response.completion_rate)
					? 0
					: parseFloat(response.completion_rate).toFixed(2);
				creativeObj.completions = UtilityService.isUndefinedOrNull(response.completion_value)
					? 0
					: parseInt(response.completion_value, 10);
			}
			if (creativeObj.isAudioCreative) {
				creativeObj.audioURL = response.audio_url;
			}
			creativeObj.isIframeExpired = response.is_iframe_expired;
			if (creativeObj.iframeUrl) {
				creativeObj.isVideoCreative = creativeObj.isIframeExpired === 1 ? false : true;
			}
			creativeObj.snapshotImage = response.snapshot_path;
			creativeObj.hasSnapshotImage = !UtilityService.isUndefinedOrNull(response.snapshot_path);
			creativeObj.adSizes = !creativeObj.isVideoCreative
				? this.mapResponseToAdSizes(response.creatives_by_ads ? response.creatives_by_ads : [])
				: ({} as { string: CreativeAdSize });
			creativeObj.hasAdSizes = !creativeObj.isVideoCreative ? !!response.creatives_by_ads : false;
			creativeObj.isIAB = UtilityService.isUndefinedOrNull(response.isIAB)
				? false
				: Number(response.isIAB)
				? true
				: false;
			creativeObj.isNative = UtilityService.isUndefinedOrNull(response.isNative)
				? false
				: Number(response.isNative)
				? true
				: false;
			creativeObj.native = response.native;
			creativeObj.percentValue100 = response['100_percent_value'];
			creativeObj.percentRate100 = response['100_percent_rate'];
			creativeObj.percentValue75 = response['75_percent_value'];
			creativeObj.percentRate75 = response['75_percent_rate'];
			creativeObj.percentValue50 = response['50_percent_value'];
			creativeObj.percentRate50 = response['50_percent_rate'];
			creativeObj.percentValue25 = response['25_percent_value'];
			creativeObj.percentRate25 = response['25_percent_rate'];
			creativeObj.mediaFiles = response.media_files;
			if (this.isSocial) {
				creativeObj.isVideoCreative = creativeObj.percentRate25 > 0 ? true : false;
				creativeObj.engagements = UtilityService.isUndefinedOrNull(response.engagements)
					? 0
					: parseFloat(response.engagements);
				creativeObj.likes = UtilityService.isUndefinedOrNull(response.likes) ? 0 : parseFloat(response.likes);
				creativeObj.comments = UtilityService.isUndefinedOrNull(response.comments) ? 0 : parseFloat(response.comments);
				creativeObj.reactions = UtilityService.isUndefinedOrNull(response.reactions)
					? 0
					: parseFloat(response.reactions);
				creativeObj.shares = UtilityService.isUndefinedOrNull(response.shares) ? 0 : parseFloat(response.shares);
				creativeObj.saves = UtilityService.isUndefinedOrNull(response.saves) ? 0 : parseFloat(response.saves);
			}
			creativeObj.youtubeVerifiedImprs = UtilityService.isUndefinedOrNull(response.youtube_verified_imprs)
				? 0
				: parseInt(response.youtube_verified_imprs, 10);
			creativeObj.youtubeVerifiedImprsRate = UtilityService.isUndefinedOrNull(response.youtube_verified_imprs_rate)
				? 0
				: parseFloat(response.youtube_verified_imprs_rate).toFixed(2);
			creativePerformances.push(creativeObj);
		}
		return creativePerformances;
	}
}
